import { t } from "@lingui/core/macro";
import { NavigationProp, useNavigation } from "@react-navigation/native";

import { SettingsButton } from "@/screens/Profile/components/SettingsButton";
import {
  MembershipIcon,
  PackagesIcon,
} from "@whoosh/design-system/src/components/icons_v2/general";
import { VStack } from "@whoosh/design-system/src/components/primitive";

import { StoreStackNavigatorParamList } from "../../StoreStackNavigator";

export const StoreHomeMobile = () => {
  const navigation =
    useNavigation<NavigationProp<StoreStackNavigatorParamList>>();

  const goToMemberships = () => {
    navigation.navigate("Memberships");
  };

  const goToPackages = () => {
    navigation.navigate("Packages");
  };

  return (
    <VStack>
      <SettingsButton
        title={t`Memberships`}
        icon={<MembershipIcon />}
        showDivider
        onPress={goToMemberships}
      />
      <SettingsButton
        title={t`Packages`}
        icon={<PackagesIcon />}
        onPress={goToPackages}
      />
    </VStack>
  );
};
